import React, { useEffect, useState } from "react";
import { Button, FormControl, FormHelperText, InputLabel, Select, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const ContactKanbanStage = ({ ticket, onUpdate }) => {
  const [data, setData] = useState(null);
  const [stage, setStage] = useState("");
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setData(null); setFailed(false);
    api.get(`/tickets/${ticket.id}/kanban`).then(({ data: result }) => {
      if (active) { setData(result); setStage(result.stage.id); }
    }).catch(error => { if (active) { setFailed(true); toastError(error); } });
    return () => { active = false; };
  }, [ticket.id, retry]);
  useEffect(() => {
    if (ticket.kanbanStage?.id) {
      setStage(ticket.kanbanStage.id);
      setData(previous => previous ? { ...previous, stage: ticket.kanbanStage } : previous);
    }
  }, [ticket.kanbanStage?.id]);
  const save = async () => {
    setBusy(true);
    try {
      const { data: updated } = await api.put(`/tickets/${ticket.id}/kanban`, { columnId: stage });
      setData(previous => ({ ...previous, stage: updated.kanbanStage }));
      onUpdate(updated);
      toast.success("Etapa do lead atualizada.");
    } catch (error) { toastError(error); }
    finally { setBusy(false); }
  };
  return <>
    <Typography variant="subtitle1" style={{ marginBottom: 8 }}>Etapa do Kanban</Typography>
    {failed ? <Button onClick={() => setRetry(value => value + 1)}>Tentar novamente</Button> : !data ?
      <Typography variant="body2" color="textSecondary" role="status">Carregando etapas…</Typography> :
      data.isGroup ? <Typography variant="body2">Grupos permanecem na lista Grupos.</Typography> : <>
        <FormControl variant="outlined" size="small" fullWidth disabled={busy}>
          <InputLabel htmlFor="contact-kanban-stage">Etapa do lead</InputLabel>
          <Select native label="Etapa do lead" value={stage} onChange={event => setStage(event.target.value)} inputProps={{ id: "contact-kanban-stage" }}>
            <option value="inbox">Entrada</option>
            {data.columns.map(column => <option key={column.id} value={column.id}>{column.name}</option>)}
          </Select>
          <FormHelperText>A etapa é aplicada ao contato e às suas conversas.</FormHelperText>
        </FormControl>
        <Button color="primary" variant="contained" size="small" disabled={busy || stage === data.stage.id} onClick={save} style={{ marginTop: 8, alignSelf: "flex-start" }}>
          {busy ? "Salvando…" : "Atualizar etapa"}
        </Button>
      </>}
  </>;
};
export default ContactKanbanStage;
